import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminBooks,
  saveAdminBook,
  getAdminBookChapters,
  saveAdminBookChapter,
} from "../../api/admin/book.api";

/* ============================================================
   FETCH BOOKS
============================================================ */

export const fetchBooks = createAsyncThunk(
  "admin/book/fetchBooks",
  async (courseCategoryId, { rejectWithValue }) => {
    try {
      const res = await getAdminBooks(courseCategoryId);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch books."
      );
    }
  }
);

/* ============================================================
   SAVE / UPDATE BOOK
============================================================ */

export const saveBookThunk = createAsyncThunk(
  "admin/book/saveBook",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await saveAdminBook(formData);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to save book."
      );
    }
  }
);

/* ============================================================
   FETCH BOOK CHAPTERS
============================================================ */

export const fetchBookChapters = createAsyncThunk(
  "admin/book/fetchBookChapters",
  async (bookId, { rejectWithValue }) => {
    try {
      const res = await getAdminBookChapters(bookId);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to fetch book chapters."
      );
    }
  }
);

/* ============================================================
   SAVE / UPDATE BOOK CHAPTER
============================================================ */

export const saveBookChapterThunk = createAsyncThunk(
  "admin/book/saveBookChapter",
  async (chapterData, { rejectWithValue }) => {
    try {
      const res = await saveAdminBookChapter(chapterData);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return res;
    } catch (error) {
      return rejectWithValue(
        error.message || "Failed to save chapter."
      );
    }
  }
);